var map = {
	"./CollectionsTableMobile.vue": [
		80431,
		4736,
		3064,
		431
	],
	"./CollectionsTableWeb.vue": [
		54532,
		4736,
		3064,
		4532
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 40894;
module.exports = webpackAsyncContext;